import { Link } from "react-router-dom";
import UnauthorizedFooter from "./unauthorizedFooter";
import UnauthorizedNavbar from "./unauthorizedNavbar";

const Policies = () => {
  return (
    <>
      <UnauthorizedNavbar />

      <div style={{ paddingBottom: "260px", paddingTop: '40px', paddingLeft:'20px'}}>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <Link to="/privacy-policy" className="text-gray-400 hover:text-white">
              Privacy Policy
            </Link>
        </ul>
      </div>

      <UnauthorizedFooter />
    </>
  );
};

export default Policies;
